module.exports = __webpack_public_path__ + "static/img/class_28.9d866711.jpg";